import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <G fill="#333">
        <Path d="M26.657 11.355c-4.477-4.473-11.823-4.473-16.3 0-4.476 4.474-4.476 11.816 0 16.29a11.436 11.436 0 0016.185 0c4.591-4.474 4.591-11.816.115-16.29zm-14.693 1.606c3.33-3.326 8.494-3.556 12.167-.803L11.276 25.121c-2.87-3.556-2.526-8.833.688-12.16zm.919 13.766l12.855-12.848c2.755 3.556 2.526 8.833-.803 12.16-3.329 3.326-8.494 3.556-12.052.688z" />
        <G fillRule="evenodd" clipRule="evenodd">
          <Path d="M20.894 12.237h-2.229c-.682 0-1.238.543-1.238 1.21v.727h-.633a.408.408 0 00-.412.403c0 .223.185.404.412.404h.642c.105 1.18 1.119 2.098 2.343 2.098 1.3 0 2.353-1.03 2.353-2.3v-1.332c0-.667-.556-1.21-1.238-1.21zM18.743 18.2c-.308.139-.581.34-.804.586l-2.269 2.316h-3.167c-.697 0-1.266.568-1.266 1.263s.57 1.262 1.266 1.262h3.546c.388 0 .774-.097 1.064-.388l.377-.379v3.18a.43.43 0 00.338.42h3.883a.421.421 0 00.421-.42v-5.653c0-1.728-1.8-2.902-3.389-2.187z" />
          <Path d="M12.54 20.408h2.842c.218 0 .395-.193.395-.43v-3.074c0-.237-.177-.43-.395-.43h-1.026v.74c0 .238-.177.43-.395.43-.218 0-.394-.192-.394-.43v-.74H12.54c-.218 0-.394.193-.394.43v3.073c0 .238.176.431.394.431z" />
        </G>
      </G>
    </Svg>
  );
}

export default SvgComponent;
